import { isFeature } from 'Cloud/Application/FeaturesEs6';

/**
 * Не показываем диалог о недосутпности тарифа анонимам, если аноним открыл ссылку на покупку, а тарифа нет в фиче для анонимов.
 * Не показываем, так как следом форсится поднятие окна авторизации, после авторизации тариф становится досутпным.
 * А диалог с предупреждением промаргивает, но в целом зря.
 */
export const skipNoTariffDialogForAnon = isFeature('skip-no-tariff-dialog-for-anon');
